<template>
    <div>
        <div v-if="lineChartVisible" id="lineChart" class="chartDiv"></div>
        <div v-if="noDataVisible" id="noDataChart">{{ chartData.noDataTips }}</div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                lineChartVisible: true,
                noDataVisible: false,
                lineChart: null,
            }
        },
        props: {
            chartData: {
                type: Object,
                default () {
                    return null;
                },
            },
        },
        methods: {
            drawChart() {
                if (this.chartData.type == 'line') {
                    this.noDataVisible = false;
                    this.drawLine(false);
                } else if (this.chartData.type == 'noData') {
                    this.lineChartVisible = false;
                    this.noDataVisible = true;
                }
            },
            drawLine(skipAnimation) {
                this.lineChart = this.$echarts.init(document.getElementById('lineChart'));
                if(skipAnimation){
                    this.lineChart.hideLoading();
                }
                let pointSize = 5;
                if(this.chartData.pointSize != null){
                    pointSize=this.chartData.pointSize;
                }
                const xAxisData = [];
                if (this.chartData.xDataDirect == "horizontal") {
                    for (let i = 0; i < this.chartData.xAxisData.length; i++) {
                        xAxisData.push(this.chartData.xAxisData[i]);
                    }
                } else {
                    for (let i = 0; i < this.chartData.xAxisData.length; i++) {
                        xAxisData.push(this.chartData.xAxisData[i].split("").join("\n"));
                    }
                }

                let option = {
                    //标题
                    title: {
                        text: this.chartData.mainTitle,
                        subtext: this.chartData.subTitle,
                        textStyle: { //主标题的属性
                            color: '#464646', //颜色
                            fontSize: 18, //大小
                            fontWeight: 'bold',
                        },
                        subtextStyle: { //副标题的属性
                            color: '#6E7079',
                            fontSize: 16, //大小
                            // 同主标题
                        },
                    },
                    color: ['#5470C6'],
                    xAxis: {
                        // x轴名称样式
                        nameTextStyle: {
                            fontWeight: 400,
                            fontSize: 15
                        },
                        type: 'category',
                        boundaryGap: false, //坐标轴两边不留白
                        data: xAxisData,
                        axisLabel: this.fotmatterXAxisLabel(),
                    },
                    yAxis: {
                        nameTextStyle: {
                            fontWeight: 400,
                            fontSize: 15
                        },
                        type: 'value',
                        boundaryGap: ["0", "0.1"],
                    },
                    dataZoom:
                    [
                        {
                            type: 'inside', //用于添加滚轮缩放
                            startValue: 0,
                        },
                    ],
                    grid: {
                        x: 50,
                        y: 40,
                        x2: 50,
                        y2: 40,
                        containLabel: false,
                    },
                    series: this.handleLineSeriesData("line",pointSize),
                };

                this.lineChart.setOption(option);
            },
            handleLineSeriesData(type,pointSize) {
                const series = [];

                for (let lineData of this.chartData.lineDatas) {
                    let serie = {
                        type: type,
                        name: lineData.name,
                        data: lineData.data,
                        symbolSize: pointSize,   //折线点的大小
                        smooth: true,
                    };
                    series.push(serie);
                }

                return series;
            },
            fotmatterXAxisLabel(data){
                let xAxisLabel = {
                    formatter: function(data) {
                        return data.replace(/\n/g, '');
                    }
                };

                return xAxisLabel;
            },
            base_encode(str) {
                /*
                var codeArray  = ["/", "+", "="];
                var regArray = ["_a", "_b", "_c"];
                for(var i=0; i<codeArray.length; i++){
                    str = str.replace(/\codeArray[i]/g, regArray[i]);
                }
                */
                str = str.replace(/\//g, '_a');
                str = str.replace(/\+/g, '_b');

                return str;
            },
            getChartImgData(){
                const imgObj = this.lineChart.getDataURL({
                    type: 'png',
                    backgroundColor: 'white'
                });
                return this.base_encode(imgObj.toString().split(',')[1]);
            },
        },
        mounted() {
            this.drawChart();
        },
        watch: {
            chartData(newValue, oldValue) {
                this.chartData = newValue;
                this.drawChart();
            }
        }
    }
</script>

<style>
    .chartDiv {
        width: 100%;
        height: 100%;
    }

    #noDataChart {
        width: 100%;
        height: 100%;
        color: '#8a8e91';
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>



// WEBPACK FOOTER //
// simpleLineChart.vue?59030a8e